import { createState, createStateInjector, createStateProvider, createStateToken } from '../state';
import type { UiAccordionDirective } from './accordion.directive';

/**
 * The state token for the Accordion primitive
 */
export const uiAccordionStateToken = createStateToken<UiAccordionDirective<unknown>>('Accordion');

/**
 * Provides the Accordion state
 */
export const provideUiAccordionState = createStateProvider(uiAccordionStateToken);

/**
 * Injects the Accordion state
 */
export const injectUiAccordionState = createStateInjector(uiAccordionStateToken);

/**
 * The Accordion state registration function
 */
export const uiAccordionState = createState(uiAccordionStateToken);
